"use client"

import { useEffect } from "react"

export function ServiceWorkerRegistration() {
  useEffect(() => {
    if (process.env.NODE_ENV !== "production") {
      return
    }

    // Preview deployments should always load freshest assets while testing.
    if (window.location.hostname.endsWith(".vercel.app")) {
      if ("serviceWorker" in navigator) {
        void navigator.serviceWorker
          .getRegistrations()
          .then((registrations) => {
            for (const registration of registrations) {
              void registration.unregister()
            }
          })
      }
      return
    }

    if ("serviceWorker" in navigator) {
      void navigator.serviceWorker.register("/sw.js")
    }
  }, [])

  return null
}
